import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { signInRequest } from '~/store/modules/auth/actions';
import { BackgroundImage, FormGroup, Label, LoginCard, Logo, PageContainer, StyledForm, StyledInput, SubmitButton } from './styles';

import backgroundImages from './images';

const schema = Yup.object().shape({
  email: Yup.string().email('Enter a valid e-mail').required('Must enter an e-mail'),
  password: Yup.string().required('Must enter the password'),
});

export default function SignIn() {
  const [background, setBackground] = React.useState('');

  useEffect(() => {
    const randomImage = backgroundImages[Math.floor(Math.random() * backgroundImages.length)];
    setBackground(randomImage);
  }, []);

  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);

  function handleSubmit({ email, password }) {
    dispatch(signInRequest(email, password));
  }

  return (
    <PageContainer>
      <BackgroundImage>
        {background && (
          <img
            src={background}
            alt="Corporate background"
            loading="lazy"
            key={background} // Key forces re-render if image changes
          />
        )}
      </BackgroundImage>

      <LoginCard>
        <Logo>
          <img src="images/logos/newlogo.png" alt="Rugged Books Logo" loading="lazy" />
        </Logo>

        <StyledForm schema={schema} onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="email">Email Address</Label>
            <StyledInput id="email" name="email" type="email" placeholder="your.email@company.com" />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="password">Password</Label>
            <StyledInput id="password" name="password" type="password" placeholder="••••••••" />
          </FormGroup>

          <SubmitButton type="submit" disabled={loading}>
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg
                  style={{
                    animation: 'spin 1s linear infinite',
                    marginRight: '0.5rem',
                  }}
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" opacity="0.25" />
                  <path
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    fill="currentColor"
                    opacity="0.75"
                  />
                </svg>
                Signing in...
              </span>
            ) : (
              'Sign in'
            )}
          </SubmitButton>
        </StyledForm>
      </LoginCard>
    </PageContainer>
  );
}
